module.exports = __webpack_public_path__ + "img/calendar-blank.ebc898fa.svg";